<div class="popup-content">
  <h2>{{warning.heading}}</h2>
    <p>
      <span>{{warning.tab_switch_attempt}}</span>
      <span>{{warning.auto_submit}}</span>
    </p>
</div>
